/* Modulos */
import {APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';


import {CookieService} from 'ngx-cookie-service';

/*https://www.npmjs.com/package/angularx-social-login*/
import {GoogleLoginProvider, SocialAuthServiceConfig, SocialLoginModule} from '@abacritt/angularx-social-login';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {JwtModule} from '@auth0/angular-jwt';
import { HostInterceptor } from './core/services/interceptors/host.interceptor';
import { ConfigService } from './core/services/config/config.service';
import { GoogleAuthenticationService } from './core/services/login/google-authentication.service';
import { SharedModule } from './shared/shared.module';
import { FlightModule } from './flight/fight.module';
import { PagesModule } from './pages/pages.module';
import { ExternalModule } from './pages/external/external.module';
import { ServiceWorkerModule } from '@angular/service-worker';
import { LoadingBackdropComponent } from './shared/components/loading-backdrop/loading-backdrop.component';

const googleLoginOptions = {
  scopes: 'profile email https://www.googleapis.com/auth/directory.readonly'
};

export function tokeGetter() {
  return localStorage.getItem('latam-user-token');
}

// Load config
export function initializeApp(configService: ConfigService) {
  return () => configService.load();
}

export function socialConfigFactory(configService: ConfigService) {
  let providers = [];
  providers.push({
    id: GoogleLoginProvider.PROVIDER_ID,
    provider: new GoogleLoginProvider(configService.GSuiteClientID, googleLoginOptions),
  });

  const config = {
    autoLogin: true,
    providers: providers,
  } as SocialAuthServiceConfig;

  return config
}

@NgModule({ declarations: [AppComponent],
    exports: [AppComponent],
    // schemas: [CUSTOM_ELEMENTS_SCHEMA],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        SocialLoginModule,
        JwtModule.forRoot({
            config: {
                tokenGetter: tokeGetter
            }
        }),
        SharedModule,
        FlightModule,
        PagesModule,
        ExternalModule,
        LoadingBackdropComponent,
        ServiceWorkerModule.register('/ngsw-worker.js', { enabled: true })], providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: initializeApp,
            deps: [ConfigService],
            multi: true
        },
        GoogleAuthenticationService,
        CookieService,
        {
            provide: 'SocialAuthServiceConfig',
            useFactory: socialConfigFactory,
            deps: [ConfigService],
        },
        {
            provide: HTTP_INTERCEPTORS, useClass: HostInterceptor, multi: true
        },
        provideHttpClient(withInterceptorsFromDi())
    ] })

export class AppModule {
}
